import { Link } from 'react-router-dom';
import { timeline } from '@/mocks/news';

export default function TimelineSection() {
  return (
    <section id="timeline" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <span className="font-label text-xs tracking-[0.25em] text-accent-600">TIMELINE</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">时间线补瓜</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              热点是连着发生的。按时间顺序看一遍，你会发现很多话题其实彼此关联，补课效率也会更高。
            </p>
            <div className="mt-6 rounded-lg bg-secondary-100 p-5">
              <p className="flex items-start gap-2 text-sm leading-relaxed text-secondary-900">
                <i className="ri-lightbulb-line mt-0.5 text-secondary-600" aria-hidden="true"></i>
                建议先看最新一条，再往前追溯原因，脉络会更清楚。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative border-l-2 border-background-300 pl-6 md:pl-8">
              {timeline.map((item) => (
                <li key={item.title} className="relative pb-8 last:pb-0">
                  <span className="absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-50 bg-accent-500 md:-left-[39px]"></span>
                  <div className="rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 md:p-5">
                    <div className="flex flex-wrap items-center gap-3 text-xs">
                      <span className="font-heading text-sm font-bold text-primary-600">{item.date}</span>
                      <span className="rounded-full bg-background-200 px-2.5 py-1 text-foreground-700">{item.category}</span>
                    </div>
                    <h3 className="mt-2.5 font-heading text-base font-bold text-foreground-950 md:text-lg">
                      <Link to={`/article/${item.articleId}`} className="transition-colors hover:text-primary-600">
                        {item.title}
                      </Link>
                    </h3>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}